import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=73bad749&scoped=true&"
import script from "./attestation.vue?vue&type=script&lang=js&"
export * from "./attestation.vue?vue&type=script&lang=js&"
import style0 from "./attestation.vue?vue&type=style&index=0&id=73bad749&lang=scss&scoped=true&"
import style1 from "./attestation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bad749",
  null
  
)

export default component.exports